import { useTranslation } from "react-i18next";

import { FoodManagementControls } from "../types/FoodManagementTypes";

export function useControlPointTypeTranslations() {
  const { t } = useTranslation();
  return {
    [FoodManagementControls.cleaningFloor]: t("food.Cleaning Floor"),
    [FoodManagementControls.cleaningHood]: t("food.Cleaning Hood"),
    [FoodManagementControls.cleaningDishwasher]: t("food.Dishwasher Control"),
    [FoodManagementControls.revisionOfControls]: t("food.Revision of Controls"),
    [FoodManagementControls.pestsRevision]: t("food.Pest Inspection"),
    [FoodManagementControls.pestsRouding]: t("food.Pests Rounding"),
    [FoodManagementControls.maintenanceExamination]: t(
      "food.Maintenance Examination",
    ),
    [FoodManagementControls.thermometerVerification]: t(
      "food.Thermometer Verification",
    ),
    [FoodManagementControls.goodsReceipt]: t("food.Goods Receipt"),
    [FoodManagementControls.freezer]: t("food.Freezer"),
    [FoodManagementControls.cooler]: t("food.Cooler"),
    [FoodManagementControls.fishCooler]: t("food.Fish Cooler"),
    [FoodManagementControls.coldRoom]: t("food.Cold Room"),
    [FoodManagementControls.heatingTreatment]: t("food.Heating Treatment"),
    [FoodManagementControls.heatRetetion]: t("food.Heat Retetion"),
    [FoodManagementControls.coolingFood]: t("food.Food Refrigeration"),
    [FoodManagementControls.reheatingFood]: t("food.Reheating Food"),
    [FoodManagementControls.vegetablespHbeginning]: t(
      "food.Fermented Vegetable Start",
    ),
    [FoodManagementControls.vegetablespH48Hours]: t(
      "food.Fermented Vegetable 48 Hours",
    ),
    [FoodManagementControls.vegetablespHfinal]: t(
      "food.Fermented Vegetable End",
    ),
    [FoodManagementControls.picklespH]: t("food.Pickles Ph Measurement"),
    [FoodManagementControls.sushiricepH]: t("food.Sushi Rice pH"),
    [FoodManagementControls.openbuffet]: t("food.Open Buffet"),
    [FoodManagementControls.freezingfish]: t("food.Freezing Fish"),
  };
}
